<template lang="pug">
    div
        data-table-searchbox.px-3(v-model="search" @search="checkAndFetch()")
        data-table-filters(:filters="propFilters" @filter="activeFilters = $event")
        data-table-pagination(v-if="!showAll" v-model="pagination" :length="apiData.lastPage" :from="apiData.from" :to="apiData.to" :total="apiData.total")
        v-data-table.full-width-datatable(
            :loading="loading"
            :items="items"
            :headers="activeHeaders"
            :pagination.sync="showAll ? null : pagination"
            :totalItems="apiData.total"
            :select-all="checkable"
            :item-key="itemKey"
            v-model="selected"
            :rows-per-page-items="[15, 25, 50, {'text':'Todos','value':-1}]"
            rows-per-page-text="Por Página"
            no-results-text="No se han encontrado resultados"
            no-data-text="-"
            hide-actions
            ref="table"
        )
            template(slot="headers" slot-scope="props")
                tr.secondary(:style="{transition: 'none', width: isSticky ? tableWidth + 'px' : 'auto', 'margin-left': isSticky ? '-' + dtYScroll + 'px' : 0}" 
                    ref="dt-headers"
                )
                    th(v-if="checkable" ref="headCheck")
                        v-checkbox(                            
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.stop="toggleAll"
                            dark
                            color="white"
                            :style="{'text-align': 'center', 'width': checkColumnWidth + 'px'}"
                        )
                    th(v-for="(header, idx) in props.headers"
                        :key="header.value"
                        :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" 
                        @click="header.sortable ? changeSort(header.value) : null"
                        :style="{'text-align': header.align || 'left', 'width': colWidths[idx]+'px'}"
                        :ref="'head' + idx"
                    ).white--text
                        span(v-if="header.align !== 'right'") {{header.text}}
                        v-icon(small='' v-if='header.sortable').white--text arrow_upward
                        span(v-if="header.align === 'right'") {{header.text}}
                    th.white--text(v-show="!noActions" :style="{'width': colActionsWidth + 'px'}") ACCIONES
            template(slot="items" slot-scope="props")
                td(v-if="checkable")
                    v-checkbox(
                        v-model="props.selected"
                        hide-details
                        ref="colCheck"
                        :color="colors.tertiary"
                    )
                td(v-for="(header, idx) in activeHeaders" 
                    :key="idx" 
                    :style="{width: (header.width || 'inherit') }"
                    :ref="props.index === 0 ? 'col' + idx : ''"
                )
                    span(
                        v-if="header.fieldType != 'autocomplete' && (!props.selected || !header.editable)"
                        :style="{width: header.width || 'inherit'}"
                        @click="test(props)"
                    ) 
                        span( v-if="header.format === 'currency'") {{ props.item[header.value]  | mixFormatCurrency }}
                        span( v-else-if="header.format === 'rut'") {{ header.fieldType === 'computed' ? header.computed(props.item) : props.item[header.value] | mixRUTFilter }}
                        span( v-else, :style="{whiteSpace: header.whiteSpace || 'inherit'}" ) {{ header.fieldType === 'computed' ? header.computed(props.item) : props.item[header.value] | formatBooleans}}
                    v-text-field(
                        v-if="props.selected && header.editable && checkable && header.fieldType === 'text'"
                        v-bind="header.fieldProps"
                        v-model="props.item[header.value]"
                        :style="{width: header.width || 'inherit'}"
                    )
                    v-autocomplete(v-if="header.fieldType === 'autocomplete'"
                        :readonly="!(props.selected && header.editable && checkable)"
                        v-bind="header.fieldProps"
                        v-model="props.item[header.value]"
                        :items="header.options"
                        :style="{width: header.width || 'inherit'}"
                    )
                td(ref="colActions" v-show="!noActions")
                    v-layout(row)
                        v-btn(
                            icon
                            @click="$emit('show', props.item[itemKey])"
                        )
                            v-icon(color="blue") visibility
                        v-btn(
                            icon
                            @click="$emit('delete', props.item[itemKey])"
                        )
                            v-icon(color="red") delete
                        slot(:item="props.item" name="actions")
        data-table-pagination(v-if="!showAll" v-model="pagination" :length="apiData.lastPage" :from="apiData.from" :to="apiData.to" :total="apiData.total")
        div.d-flex.row(style="width: 100%; height: 58px;")
            slot(name="buttons")
</template>

<script>
import DataTableFilterrs from './partials/DataTableFilters'
import DataTableSearchbox from './partials/DataTableSearchbox'
import DataTablePagination from './partials/DataTablePagination'
import InputValidations from '@/mixins/InputValidations'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import RUTUtils from '@/mixins/RUTUtils'
import DataTablePaginationVue from './partials/DataTablePagination.vue'
export default {
    name: 'crud-data-table',
    props: {
        /**
         * @description
         * Service containing the methods for providing the table with server side data, pagination and other functions
         */
        service: {
            type: Object,
            default: () => null,
        },
        /**
         * @description
         * Headers array of objects for the Vuetify data-table.
         * Is posible to add a 'editable' attribute to the objects in this array to enable or disable
         * that particular column to be edited.
         * @example
         *  {
         *      text: key,
         *      align: 'left',
         *      sortable: 'false',
         *      value: key,
         *      editable: false,
         *      width: '100px'
         *  }
         */
        headers: {
            type: Array,
            default: () => null,
        },
        /**
         * @description
         * Array of desired filter objects to be used on the datatable.
         * @example
         *  {
         *      field: 'is_consumable',
                value: [],
                label: 'Consumible',
                options: [
                    {
                        text: 'Consumible',
                        value: true,
                    },
                    {
                        text: 'No Consumible',
                        value: false,
                    },
                ],
         *  }
         */
        filters: {
            type: Array,
            default: () => null,
        },
        /**
         * @description
         * Property that enables or disables the checkboxes in the datatable
         */
        checkable: {
            type: Boolean,
            default: () => false,
        },
        /**
         * @description
         * Key to be used to identify the items in the datatable. Defaults to the item ID
         */
        itemKey: {
            type: String,
            default: () => 'id',
        },
        /**
         * @description
         * Enables or disables the sticky header for the data table
         */
        stickyHeader: {
            type: Boolean,
            default: () => true,
        },
        /**
         * 
         */
        editableFieldsOverwrites: {
            type: Array,
            default: () => null
        },
        /**
         * disable pagination and show all results on table
         */
        showAll: {
            type: Boolean,
            default: () => false
        },
        /**
         * disable actions column
         */
        noActions: {
            type: Boolean,
            default: () => false
        }
    },
    data: function() {
        return {
            /**
             * @description
             * List of items fetched from the database
             */
            items: [],
            /**
             * @description
             * Object containing pagination info.
             * It's watched for changes to fetch new data if ordering or page changes.
             */
            pagination: {},
            /**
             * @description
             * Contains metadata of the api fetched along with the db data.
             */
            apiData: {},
            /**
             * Sets the state of the datatable. If true, the datatable will show a loading bar animation.
             */
            loading: true,
            /**
             * List of filters currently applied to the items, used to filter in every db data fetching.
             */
            activeFilters: [],
            /**
             * Content of the searchbox. Used to filter on every db data fetching.
             */
            search: '',
            /**
             * Array contained all checked items if checkboxes are enabled.
             */
            selected: [],
            /**
             * Contains value of selected items before any modifications
             */
            defaultValues: [],
            /**
             * @description
             * Array containing the width of each column, for sticky header purposes
             */
            colWidths: [],
            /**
             * @description
             * Actions column width, for sticky header purposes
             */
            colActionsWidth: 0,
            /**
             * @description
             * Actions column width, for sticky header purposes
             */
            checkColumnWidth: 0,
            /**
             * @description
             * Datatable header's initial position, for sticky header purposes
             */
            headerOffset: 0,
            /**
             * @description
             * Datatable's bottom position, for sticky header purposes
             */
            tableOffset: 0,
            tableWidth: 0,
            isSticky: false,
            dtYScroll: 0,
            stickyHeaderElement: null
        }
    },
    computed: {
        /**
         * @description
         * Function that returns the datatable headers.
         * Will use response object properties if no headers are provided by props.
         */
        activeHeaders: function() {
            let headers
            if (this.headers != null) {
                headers = this.headers
            } else if (this.items && this.items.length > 0) {
                headers = []
                for (let key in this.items[0]) {
                    if (this.items[0].hasOwnProperty(key)) {
                        headers.push({
                            text: key,
                            align: 'left',
                            sortable: 'false',
                            value: key,
                            editable: false,
                            width: null,
                        })
                    }
                }
            }
            return headers
        },
        /**
         * @description
         * Function that returns the datatable filters.
         * If no filter props has been passed, will use headers for generating textfield filters.
         */
        propFilters: function() {
            if (this.filters != null) return this.filters
            if (this.activeHeaders && this.activeHeaders.length > 0) {
                return this.activeHeaders.map(header => {
                    return {
                        field: header.value,
                        value: '',
                        label: header.value,
                        options: null,
                    }
                })
            }
        },
    },
    methods: {
        /**
         * @description
         * Handles data fetching from api using the service passed by props
         */
        fetchData: async function(filters = null, pagination = null) {
            this.loading = true
            const response = await this.service.dtFetchData(filters, pagination)
            const dt = response
            const keys = this.selected.map(item => item[this.itemKey])
            if (keys.length > 0) {
                dt.data = dt.data.map(item => {
                    if (keys.includes(item[this.itemKey]))
                        item = this.selected.find(
                            sel => sel[this.itemKey] === item[this.itemKey]
                        )
                    return item
                })
            }
            this.items = dt.data
            this.apiData = {
                currentPage: dt.current_page,
                lastPage: dt.last_page,
                path: dt.path,
                firstPageUrl: dt.first_page_url,
                prevPageUrl: dt.prev_page_url,
                nextPageUrl: dt.next_page_url,
                lastPageUrl: dt.last_page_url,
                perPage: dt.per_page,
                from: dt.from,
                to: dt.to,
                total: dt.total,
            }
            if (!pagination) {
                this.pagination = {
                    sortBy: null,
                    descending: null,
                    rowsPerPage: dt.per_page,
                    page: dt.current_page,
                }
            }
            this.loading = false
            return
        },
        test(d) {
            console.log(d)
            return false
        },
        /**
         * @description
         * checks if a editable field can be modified on the datatable
         */
        editableField: function(props) {
            if (props.selected === undefined) return true
            return false
        },
        /**
         * @description
         * Check all variables that can modify data fetching and fetchs data
         * using those variables
         */
        checkAndFetch: async function() {
            let activeFilters = JSON.parse(JSON.stringify(this.activeFilters))
            if (!activeFilters) activeFilters = []
            if (activeFilters)
                activeFilters = this.appendSearchFilter(activeFilters)
            if (activeFilters.length === 0) activeFilters = null
            let pagination = this.pagination
            await this.fetchData(activeFilters, pagination)
        },
        /**
         * @description
         *  Adds the searchbox filter to the server data request
         */
        appendSearchFilter: function(filters) {
            if (this.search && this.search.length >= 3) {
                filters.push({
                    field: 'search',
                    value: [this.search],
                })
            }
            return filters
        },
        /**
         * @description
         * handler for the "check all" checkbox
         */
        toggleAll: function() {
            let selectedKeys = this.selected.map(row => row[this.itemKey])
            let currentKeys = this.items.map(row => row[this.itemKey])

            // Check if every key to be selected is already selected
            let check = currentKeys.every(key => selectedKeys.includes(key))

            if (check) {
                this.selected = this.selected.filter(
                    row => !currentKeys.includes(row[this.itemKey])
                )
            } else {
                this.selected = this.selected.concat(
                    this.items.filter(
                        item => !selectedKeys.includes(item[this.itemKey])
                    )
                )
            }
        },
        /**
         * @description
         * handler for column sorting
         */
        changeSort: function(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
        },
        /**
         * @description
         * Update the column widths data for headers to adapt to any change on column width
         */
        updateColWidths: function() {
            //TODO: Fix Colwidth detection for checkbox columns
            this.colWidths = []
            this.activeHeaders.map((header, idx) => {
                let col = this.$refs['col' + idx][0]
                this.colWidths.push(col.offsetWidth)
            })
            let colActions = this.$refs.colActions || null
            this.colActionsWidth = colActions ? colActions.offsetWidth : null
            let checkColumn = this.$refs.colCheck ? this.$refs.colCheck.$el : null
            console.log(checkColumn, 'checkbox column')
            this.checkColumnWidth = checkColumn ? checkColumn.offsetWidth : null
            return
        },
        stickyScrolling: function() {
            const dtheaders = this.$refs['dt-headers']
            if (
                window.pageYOffset >= this.headerOffset 
                // && window.pageYOffset <= this.tableOffset
            ){
                if(this.isSticky) return
                this.stickyHeaderElement = dtheaders.cloneNode(true)
                this.stickyHeaderElement.classList.add('sticky')
                this.stickyHeaderElement.id = 'sticky-header'
                let length = this.activeHeaders.length + 2
                if(this.noActions || !this.checkable) length = this.activeHeaders.length + 1
                if(this.noActions && !this.checkable) length = this.activeHeaders.length
                console.log(length, 'length')
                for (let idx = 0; idx < length; idx++) {
                    console.log(idx)
                    this.stickyHeaderElement.children[idx].style.padding = "0 24px"
                    let icons = this.stickyHeaderElement.children[idx].getElementsByTagName('i')
                    if(icons && icons.length > 0 && idx > 0 && idx <this.activeHeaders.length + 1) icons[0].style.display = 'none'
                }
                let table = this.$refs.table.$el
                table.insertBefore(this.stickyHeaderElement, table.firstChild)
                this.isSticky = true
            } else {
                if(!this.isSticky) return
                let header = document.getElementById('sticky-header')
                header.parentNode.removeChild(header)
                this.stickyHeaderElement = null
                this.isSticky = false
            }
        },
        async refresh(){
            await this.checkAndFetch()
            this.selected = []
            this.defaultValues = []
            console.log('refresh')
        }
    },
    watch: {
        /**
         * @description
         * watch for pagination changes to fetch new data
         */
        pagination: {
            handler: async function() {
                this.checkAndFetch()
            },
            deep: true,
        },
        /**
         * @description
         * Watch for filters changes to fetch new data
         */
        activeFilters: {
            handler: async function() {
                await this.checkAndFetch()
            },
            deep: true,
        },
        /**
         * @description
         * Watch for checked rows to update checked rows in parent
         */
        selected: {
            handler: function(val, oldVal) {
                //Check if new item is checked
                if (val.length > oldVal.length) {
                    //Get list of keys of old selected items
                    let oldValKeys = oldVal.map(
                        oldItem => oldItem[this.itemKey]
                    )
                    // Compare old keys and new keys to identify new items
                    let keys = val.forEach(newItem => {
                        if (!oldValKeys.includes(newItem[this.itemKey])) {
                            //For new Items, push it's current value to the default values array, for rollback purposes
                            this.defaultValues.push(
                                JSON.parse(JSON.stringify(newItem))
                            )
                        }
                        //Is this if necesary?... 
                        //Actually it caused the bug
                        // if (oldValKeys.length === 0 || oldValKeys.includes(newItem[this.itemKey])){
                        //     this.editableFieldsOverwrites.forEach(ovw => {
                        //         if(ovw.condition(newItem)){
                        //             newItem[ovw.field] = ovw.value
                        //         }
                        //     })
                        // }
                        this.editableFieldsOverwrites.forEach(ovw => {
                            if(ovw.condition(newItem)){
                                newItem[ovw.field] = ovw.value
                            }
                        })
                    })
                }
                if (val.length < oldVal.length) {
                    // Obtenemos las keys nuevas
                    let valKeys = val.map(newItem => newItem[this.itemKey])
                    // Obtejemos las keys que se han removido
                    let keys = oldVal
                        .map(oldItem => {
                            if (!valKeys.includes(oldItem[this.itemKey])) {
                                return oldItem[this.itemKey]
                            }
                        })
                        .filter(oldItem => {
                            return oldItem
                        })
                    // Asignamos el valor por defecto a todos los items que han sido desmarcados
                    this.items = this.items.map(item => {
                        if (keys.includes(item[this.itemKey]))
                            item = this.defaultValues.find(
                                dv => dv[this.itemKey] == item[this.itemKey]
                            )
                        return item
                    })
                    this.defaultValues = this.defaultValues.filter(item => {
                        return !keys.includes(item[this.itemKey])
                    })
                }
                this.updateColWidths()
                this.$emit('select', this.selected)
            },
            deep: true,
        },
        loading: function() {
            if (this.loading === false) {
                this.updateColWidths()
                if(this.$refs.table){
                    const table = this.$refs.table.$el.children[0].children[0]
                    this.tableOffset = table.offsetHeight
                    this.tableWidth = table.offsetWidth
                }
            }
        },
        'service.dtFetchData': async function() {
            await this.fetchData()
        },
    },
    components: {
        'data-table-filters': DataTableFilterrs,
        'data-table-searchbox': DataTableSearchbox,
        'data-table-pagination': DataTablePagination,
    },
    mixins: [InputValidations, CurrencyUtils, RUTUtils],
    filters: {
        formatBooleans: function(value) {
            if (value === true) return 'SI'
            if (value === false) return 'NO'
            return value
        },
    },
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        if (!this.stickyHeader) return
        window.addEventListener('resize', this.updateColWidths)
        window.addEventListener('scroll', this.stickyScrolling)
    },
    /**
     * @description
     * Initial data loading on component creation
     */
    beforeMount: async function() {
        if (this.service) {
            await this.fetchData()
        }
    },

    // beforeMount: function(){...},
    mounted: function() {
        const dtheaders = this.$refs['dt-headers']
        this.headerOffset = dtheaders.offsetParent.offsetTop
        if (this.stickyHeader) {
            let table = dtheaders.parentElement.parentElement.parentElement
            table.addEventListener('scroll', () => {
                this.dtYScroll = table.scrollLeft
            })
        }
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    beforeDestroy: function() {
        window.removeEventListener('resize', this.updateColWidths)
        window.removeEventListener('scroll', this.stickyScrolling)
    },
    // destroyed: function(){...},
    //
    // End Lifecycle Methods

    // TODO -> Watch ref cols widths to set headers widths for fixed headers on scroll
}
</script>

<style lang="scss" scoped>
.sticky {
    position: fixed;
    z-index: 10;
    padding-top: 10px;
    top: 65px;
}
</style>
